import React from "react";
import { Checkbox } from "@my-scoot/component-library-legacy";

export const QuestionMandatoryCheckbox = ({
  record,
  handleToggleQuestionMandatory,
}) => {
  const handleChange = async (e) => {
    const value = e.target.checked;
    handleToggleQuestionMandatory({
      questionId: record.uuid,
      value,
    });
  };

  return (
    <Checkbox
      size="extra_large"
      checked={!!record.is_mandatory}
      color={"#00B77A"}
      disabled={record.is_default}
      onChange={handleChange}
    />
  );
};
